<div
  class="w-[160px] h-40 grid place-content-center rounded {{
    errorSince() ? 'border border-warn' : 'border-a-12'
  }}"
>
  <blaze-availability-date-picker
    placeholder="Since"
    [max]="value().until"
    [value]="value().since"
    (valueChanged)="onValueChanged($event, 'since')"
  />
</div>
<mat-icon svgIcon="icon_direction_right_16" class="!text-bat-value" />
<div
  class="w-[160px] h-40 grid place-content-center rounded {{
    errorUntil() ? 'border border-warn' : 'border-a-12'
  }}"
>
  <blaze-availability-date-picker
    placeholder="Until"
    [min]="value().since"
    [value]="value().until"
    (valueChanged)="onValueChanged($event, 'until')"
    (pickerClosed)="untilTouched.set(true)"
  />
</div>
<div class="text-warn whitespace-nowrap flex flex-col gap-4">
  @if (errorSince()) {
    <span>{{ errorSince() }}</span>
  }
  @if (errorUntil()) {
    <span>{{ errorUntil() }}</span>
  }
</div>
